module.exports = __webpack_public_path__ + "static/img/passo4.a77f17ae.svg";